/**
 * Age gate: cookie-based verification and redirects.
 * Uses event delegation so buttons work regardless of load order.
 */

const AGE_GATE_PAGE_PATH = '/pages/age-gate';
const COOKIE_NAME_DEFAULT = 'age_verified';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, days) {
  const maxAge = days ? days * 24 * 60 * 60 : 365 * 24 * 60 * 60;
  document.cookie = `${name}=1; path=/; max-age=${maxAge}; SameSite=Lax`;
}

function isAgeGatePage() {
  return (
    window.location.pathname === AGE_GATE_PAGE_PATH ||
    document.querySelector('[data-template="page.age-gate"]') != null
  );
}

function runRedirectCheck() {
  if (isAgeGatePage()) return;
  const name = document.body?.dataset?.ageGateCookieName || COOKIE_NAME_DEFAULT;
  if (getCookie(name)) return;
  window.location.replace(AGE_GATE_PAGE_PATH);
}

function handleAgeGateClick(e) {
  const confirmBtn = e.target.closest('[data-age-gate-confirm]');
  const denyBtn = e.target.closest('[data-age-gate-deny]');
  const section = (confirmBtn || denyBtn)?.closest('[data-age-gate]');
  if (!section) return;

  const cookieName = section.dataset.cookieName?.trim() || COOKIE_NAME_DEFAULT;
  const cookieDays = parseInt(section.dataset.cookieDays?.trim() || '365', 10);
  const redirectUrl = section.dataset.redirectUrl?.trim() || '/';
  const under21Url = section.dataset.under21Url?.trim() || '';

  if (confirmBtn) {
    e.preventDefault();
    setCookie(cookieName, cookieDays);
    window.location.href = redirectUrl;
    return;
  }

  if (denyBtn) {
    e.preventDefault();
    window.location.href = under21Url || 'https://www.google.com';
  }
}

function init() {
  runRedirectCheck();
  document.addEventListener('click', handleAgeGateClick);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
